module.exports = __webpack_public_path__ + "img/yx5-en.3cd1708d.jpg";